import moment from "moment";
import React, { useEffect, useState } from "react";
import styles from './Calendar.module.scss';
// import Slider from '@mui/material/Slider';
// import { useAppDispatch, useAppSelector } from "../../../app/hooks";
// import { selectCalendarStatus, selectEditMode, selectEndDate, selectHoursAfterDay, selectHoursBeforeDay, selectSelectedChannel, selectStartDate, selectSubmitStatus, selectSubmittedNow, selectZoom, setEndDate, setSelectedChannel, setStartDate, setZoom, submitCalendar } from "../../panels/Calendar/CalendarSlice";
import { Button, DatePicker, DatePickerInput, IconButton } from '@carbon/react'
// import { selectChannels,  } from "../../../AppSlice";
// import { selectChannelSchedule } from "../../panels/Playout/PlayoutSlice";
// import { formatDateTime } from "../../../helper";
import Icon from "../../Icon/Icon";
import CalendarZoom from "./ZoomBar";
import { useAppSelector } from "../../../app/hooks";
import { TimelimeChannel } from "./Timeline.model";
import TimelineMonitor from "./TimelineMonitor";
// import { Box, Stack, Button, CircularProgress, Typography } from "@mui/material";


export default function CalHeader({
    zoom,
    channels,
    selectedChannel,
    rowHeight,
    goToNow,
    startDate,
    hoursBeforeDay,
    hoursAfterDay,
    submittedNow,
    timelineStatus,
    onSubmit,
    onZoomChange,
    onStartDateChange,
    onSelectChannel,
    headerActions,
}: {
    zoom: number[]
    selectedChannel: string
    channels: TimelimeChannel[]
    rowHeight: number
    startDate: string
    hoursBeforeDay: number
    hoursAfterDay: number
    submittedNow: boolean
    timelineStatus: 'idle' | 'loading' | 'failed'
    goToNow: () => void,
    onSubmit: () => void
    onZoomChange: (val: number[]) => void
    onStartDateChange: (date: string) => void
    onSelectChannel: (channelId: string) => void
    headerActions?: React.ReactNode
}) {

    // const dispatch = useAppDispatch()

    // const zoom = useAppSelector(selectZoom)
    // const submittedNow = useAppSelector(selectSubmittedNow)

    // const submitStatus = useAppSelector(selectSubmitStatus)
    // const calendarStatus = useAppSelector(selectCalendarStatus)

    // const channels = useAppSelector(selectChannels)
    // const selectedChannel = useAppSelector(selectSelectedChannel)
    // const channelSchedule = useAppSelector(selectChannelSchedule)
    // const editMode = useAppSelector(selectEditMode)
    // const now = useAppSelector(selectNow)
    // const hoursBeforeDay = useAppSelector(selectHoursBeforeDay)
    // const hoursAfterDay = useAppSelector(selectHoursAfterDay)

    // const startDate = useAppSelector(selectStartDate)
    // const endDate = useAppSelector(selectEndDate)

    // const onSelectChannel = (channelId) => {
    //     dispatch(setSelectedChannel(channelId))
    //     dispatch(setUpdateActionStamp())
    // }

    // const canSubmit = () => {
    //     if (editMode) return false
    //     if (submittedNow) return false
    //     if (channelSchedule?.data?.status) {
    //         if (channelSchedule?.data?.status === 'done' || channelSchedule?.data?.status === 'Error!')
    //             return true
    //         return false
    //     }
    //     return true
    // }

    return (
        <div className={styles.header}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, minWidth: 0, flex: 1 }}>
                {headerActions ? <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>{headerActions}</div> : null}
                <div style={{ minWidth: 0, padding: 10 }}>
                    <div className={styles.title}>
                        {selectedChannel === "" ? "All Channels" : <div style= {{ marginTop: 80 }}>
                            <span style={{ color: "#5793c9", cursor: "pointer" }} onClick={e => onSelectChannel("")}>All Channels</span> {">"} {channels.find(channel => selectedChannel === channel.id)?.title}
                            <div style={{ height: 100, width: 100, backgroundColor: "#222" }}>
                                <TimelineMonitor
                                    src={channels.find(channel => selectedChannel === channel.id)?.monitorPreviewURL ?? ""}
                                    type={channels.find(channel => selectedChannel === channel.id)?.monitorPreviewType}
                                />
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 12, marginLeft: 'auto' }}>
                <div style={{ width: 350, padding: 2, display: 'flex' }}>
                    <Button kind="ghost" size='sm' title='5 days back' onClick={e => onStartDateChange(moment(startDate).subtract(5, "day").local().toISOString())} >
                        <Icon size={22} type='back_5' />
                    </Button>
                    <Button kind="ghost" size='sm' title='1 day back' onClick={e => onStartDateChange(moment(startDate).subtract(1, "day").local().toISOString())} >
                        <Icon size={16} type='left' />
                    </Button>
                    <DatePicker dateFormat="d.m.Y" value={moment(startDate).local().toISOString()} datePickerType="single" onChange={e => { onStartDateChange(moment((e[0])).startOf('day').add(12, "hours").toISOString()) }}>
                        <DatePickerInput
                            id="date-picker-calendar-id"
                            placeholder="d.m.yyyy"
                            labelText={""}
                            type="text"
                            style={{ width: '100%' }}
                        />
                    </DatePicker>
                    <Button kind="ghost" size='sm' title='Current time' className='cds--btn--icon-only' onClick={goToNow} >
                        <Icon size={16} color="green" type='today' />
                    </Button>
                    <Button kind="ghost" size='sm' title='1 day forward' className='cds--btn--icon-only' onClick={e => onStartDateChange(moment(startDate).add(1, "day").local().toISOString())} >
                        <Icon size={16} type='right' />
                    </Button>
                    <Button kind="ghost" size='sm' title='5 days forward' className='cds--btn--icon-only' onClick={e => onStartDateChange(moment(startDate).add(5, "day").local().toISOString())} >
                        <Icon size={22} type='next_5' />
                    </Button>
                </div>
                <div style={{ width: 250, height: 20, position: 'relative', backgroundColor: '#333' }}>
                    <CalendarZoom zoom={zoom} onChange={val => onZoomChange(val)} />
                </div>
            </div>
            <div style={{ width: 300, position: "absolute", right: 0, padding: 15, pointerEvents: 'none' }}>
                {selectedChannel && selectedChannel !== "ACTIVE" ? <>
                    {/* {submittedNow ? 'Submittting now...' : (channelSchedule?.data?.status === 'done' ? `Done! Submitted at: ${formatDateTime(channelSchedule?.updated)}` : channelSchedule?.data?.status)} */}
                </> : null}
            </div>

            {/*  <table>
            //     <tr>
            //         <td style={{ width: 500, padding: 18, textAlign: "end" }}>
            //             
            //         </td>*/}
            {/* <td style={{ width: 75, padding: 0, verticalAlign: 'middle' }}><Button disabled={!canSubmit()} style={{ backgroundColor: "green" }} size="sm" onClick={submit}>Submit</Button></td> */}
            {/*      </tr>
            // </table> : null} */}
        </div>
    )
}
